export default __webpack_public_path__ + "static/media/ic_glp_avax.e34f1e49.svg";